import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import MainApp from './components/MainApp';
import InviteAccept from './components/InviteAccept';
import { NotificationProvider } from './components/NotificationSystem';
import { API_URL } from './config';
import './App.css';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user') || 'null'));
  const [validating, setValidating] = useState(true);

  // Validate session on mount
  useEffect(() => {
    const validateSession = async () => {
      const storedToken = localStorage.getItem('token');
      
      if (!storedToken) {
        setValidating(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/validate`, {
          headers: {
            'Authorization': `Bearer ${storedToken}`
          }
        });

        if (!response.ok) {
          // Invalid session, clear and redirect to login
          console.log('Session invalid, clearing...');
          handleLogout();
        } else {
          const data = await response.json();
          if (data.valid) {
            // Update user data if it changed
            setUser(data.user);
            localStorage.setItem('user', JSON.stringify(data.user));
          } else {
            handleLogout();
          }
        }
      } catch (error) {
        console.error('Session validation error:', error);
        // On error, assume session is invalid
        handleLogout();
      } finally {
        setValidating(false);
      }
    };

    validateSession();
  }, []);

  const handleLogin = (newToken, newUser) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  // Show loading state while validating
  if (validating) {
    return (
      <div className="App" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#36393f', color: '#fff' }}>
        <div>Validating session...</div>
      </div>
    );
  }

  return (
    <NotificationProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route 
              path="/login" 
              element={token ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} 
            />
            <Route 
              path="/register" 
              element={token ? <Navigate to="/" /> : <Register onLogin={handleLogin} />} 
            />
            <Route 
              path="/invite/:code" 
              element={<InviteAccept token={token} user={user} />} 
            />
            <Route 
              path="/" 
              element={token ? <MainApp token={token} user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} 
            />
          </Routes>
        </div>
      </Router>
    </NotificationProvider>
  );
}

export default App;
